import React, { useEffect, useMemo, useState } from 'react';
import { useThree, useLoader } from '@react-three/fiber';
import { TextureLoader } from 'three/src/loaders/TextureLoader';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import * as THREE from 'three';

export function ImageMaterial({ url, isImage = true }) {
  const [texture]: any = useLoader(isImage ? TextureLoader : SVGLoader, [url]);
  useEffect(() => {
    if (texture) {
      (texture as any).colorSpace = (THREE as any).SRGBColorSpace;
    }
  }, [texture]);

  return <meshBasicMaterial map={texture} side={THREE.FrontSide} />;
}
